import { notify } from "../lib/notify";

export function useNotify() {
  return notify;
}

export default useNotify;
